import React, { createContext, useContext, useState } from 'react';

const translations = {
  en: {
    // Navbar
    home: 'HOME',
    about: 'ABOUT',
    curriculum: 'CURRICULUM',
    enroll: 'ENROLL',
    testimonials: 'TESTIMONIALS',
    login: 'Log In',
    logout: 'Logout',
    dashboard: 'Dashboard',
    
    // Hero Section
    masterclassAvailable: 'MASTERCLASS AVAILABLE NOW',
    theSacred: 'The Sacred',
    energyUnion: 'Energy Union',
    heroSubtitle: 'Healing Masculine And Feminine at the Root',
    startYourJourney: 'Start Your Journey',
    exploreCurriculum: 'Explore Curriculum',
    
    // Language Section
    selectLanguage: 'Select Language',
    selectLanguageDesc: 'Choose your preferred language for the website content.',
    
    // Welcome Section
    welcomeMessage: 'Welcome Message',
    welcomeDesc: 'Start your journey with an inspiring message from our instructors.',
    
    // Why This Course
    whyThisCourse: 'Why This Course?',
    whyDesc: "In a world that often forces us to choose sides, true power lies in integration. This course isn't just about learning concepts; it's about embodying the full spectrum of your human potential.",
    restoreBalance: 'Restore Balance',
    restoreBalanceDesc: 'Learn to oscillate healthily between action and rest, giving and receiving.',
    transformRelationships: 'Transform Relationships',
    transformRelationshipsDesc: 'Understand the polarity that creates attraction and deepens connection.',
    unlockCreativity: 'Unlock Creativity',
    unlockCreativityDesc: 'Access the flow state where your best ideas and truest expression live.',
    spiritualPath: 'Spiritual Path',
    spiritualPathDesc: 'Use your daily life and relationships as a vehicle for spiritual awakening.',
    whatYouWillExperience: 'What You Will Experience',
    experience1: 'Deep emotional release and healing of past wounds',
    experience2: "Clarity on your life's purpose and direction",
    experience3: 'Tools to manage stress and anxiety through energy work',
    experience4: 'A supportive community of like-minded seekers',
    experience5: 'Practical rituals for daily alignment',
    experience6: 'Enhanced intuition and self-trust',
    
    // Curriculum
    courseCurriculum: 'Course Curriculum',
    curriculumDesc: 'A journey of transformation, module by module.',
    part1Title: 'Foundations of Energy',
    part1Subtitle: 'Understanding the core principles',
    part2Title: 'The Masculine Archetype',
    part2Subtitle: 'Awakening the protector within',
    part3Title: 'The Feminine Flow',
    part3Subtitle: 'Embracing intuition and creativity',
    part4Title: 'Divine Union',
    part4Subtitle: 'Harmonizing the energies for wholeness',
    unlock: 'Unlock',
    
    // Free Bonus
    freeBonus: 'Free Bonus',
    freeBonusDesc: 'As a special gift, receive our exclusive Vibrational Frequencies Library, designed to amplify your energy work and meditation practice.',
    downloadBonus: 'Download Your Free Bonus Now',
    bonusValue: 'Over $99 Value - Yours FREE!',
    
    // Pricing
    investInTransformation: 'Invest in Your Transformation',
    pricingDesc: 'Choose the path that leads to your inner harmony and balance.',
    mostPopular: 'Most Popular',
    fullCourseAccess: 'Full Course Access',
    oneTimePayment: 'One-time payment • Lifetime access',
    feature1: 'Lifetime access to all course modules',
    feature2: 'Exclusive guided meditations',
    feature3: 'Community forum access',
    feature4: 'Bonus Q&A sessions with instructors',
    feature5: 'Downloadable workbooks & resources',
    feature6: 'Certificate of Completion',
    signInToEnroll: 'Sign In with Google to Enroll',
    completeEnrollment: 'Complete Enrollment',
    accessCourse: 'Access Your Course',
    securePayment: 'Secure Payment',
    satisfactionGuarantee: 'Satisfaction Guarantee',
    
    // Instructors
    meetYourGuides: 'Meet Your Guides',
    guidesDesc: 'Learn from world-renowned experts in energy healing.',
    masculineEnergyMaster: 'Masculine Energy Master',
    feminineEnergyMaster: 'Feminine Energy Master',
    nawwafDesc: 'Dr. Nawwaf Alshibli is a visionary leader and spiritual guide, renowned for his profound insights into ancient wisdom and modern psychology. With decades of experience, he empowers individuals to unlock their true potential and find inner harmony.',
    inanaDesc: 'Inanna Nolan is a celebrated energy healer and mentor, specializing in feminine embodiment and sacred sensuality. Her compassionate approach helps women reclaim their power, intuition, and authentic expression, guiding them towards radical self-love and balanced living.',
    energyHealingCourse: 'Energy Healing Course',
    togetherDesc: 'Together, Dr. Nawwaf and Inanna bring a unique blend of masculine and feminine wisdom, guiding you on a holistic journey to balance and empowerment.',
    
    // Testimonials
    whatStudentsSay: 'What Our Students Say',
    testimonialsDesc: 'Real stories from those who found their balance.',
    testimonialRating: 'Testimonials rating',
    
    // Footer
    footerDesc: 'Transform your life through our comprehensive Masculine and Feminine Energy Healing Course. Learn from Dr. Nawwaf Alshibli and Inanna Nolan to balance and harmonize your inner energies.',
    quickLinks: 'Quick Links',
    contact: 'Contact',
    privacyPolicy: 'Privacy Policy',
    termsOfService: 'Terms of Service',
    allRightsReserved: 'All rights reserved.',
  },
  ar: {
    // Navbar
    home: 'الرئيسية',
    about: 'حول',
    curriculum: 'المنهج',
    enroll: 'التسجيل',
    testimonials: 'الشهادات',
    login: 'تسجيل الدخول',
    logout: 'تسجيل الخروج',
    dashboard: 'لوحة التحكم',
    
    // Hero Section
    masterclassAvailable: 'الدورة المتقدمة متاحة الآن',
    theSacred: 'الاتحاد',
    energyUnion: 'المقدس للطاقة',
    heroSubtitle: 'شفاء الطاقة الذكورية والأنثوية من الجذور',
    startYourJourney: 'ابدأ رحلتك',
    exploreCurriculum: 'استكشف المنهج',
    
    // Language Section
    selectLanguage: 'اختر اللغة',
    selectLanguageDesc: 'اختر لغتك المفضلة لمحتوى الموقع.',
    
    // Welcome Section
    welcomeMessage: 'رسالة ترحيب',
    welcomeDesc: 'ابدأ رحلتك برسالة ملهمة من مدربينا.',
    
    // Why This Course
    whyThisCourse: 'لماذا هذه الدورة؟',
    whyDesc: 'في عالم يجبرنا غالباً على اختيار جانب، تكمن القوة الحقيقية في التكامل. هذه الدورة ليست مجرد تعلم مفاهيم؛ إنها تجسيد الطيف الكامل لإمكاناتك البشرية.',
    restoreBalance: 'استعادة التوازن',
    restoreBalanceDesc: 'تعلم التأرجح الصحي بين العمل والراحة، العطاء والاستقبال.',
    transformRelationships: 'تحويل العلاقات',
    transformRelationshipsDesc: 'فهم القطبية التي تخلق الجاذبية وتعمق الاتصال.',
    unlockCreativity: 'إطلاق الإبداع',
    unlockCreativityDesc: 'الوصول إلى حالة التدفق حيث تعيش أفضل أفكارك وتعبيرك الحقيقي.',
    spiritualPath: 'المسار الروحي',
    spiritualPathDesc: 'استخدم حياتك اليومية وعلاقاتك كوسيلة للصحوة الروحية.',
    whatYouWillExperience: 'ما ستختبره',
    experience1: 'إطلاق عاطفي عميق وشفاء الجروح الماضية',
    experience2: 'وضوح حول هدف حياتك واتجاهها',
    experience3: 'أدوات لإدارة التوتر والقلق من خلال عمل الطاقة',
    experience4: 'مجتمع داعم من الباحثين ذوي التفكير المماثل',
    experience5: 'طقوس عملية للمحاذاة اليومية',
    experience6: 'تعزيز الحدس والثقة بالنفس',
    
    // Curriculum
    courseCurriculum: 'منهج الدورة',
    curriculumDesc: 'رحلة التحول، وحدة بوحدة.',
    part1Title: 'أسس الطاقة',
    part1Subtitle: 'فهم المبادئ الأساسية',
    part2Title: 'النموذج الذكوري',
    part2Subtitle: 'إيقاظ الحامي الداخلي',
    part3Title: 'التدفق الأنثوي',
    part3Subtitle: 'احتضان الحدس والإبداع',
    part4Title: 'الاتحاد الإلهي',
    part4Subtitle: 'تناغم الطاقات من أجل الكمال',
    unlock: 'فتح',
    
    // Free Bonus
    freeBonus: 'هدية مجانية',
    freeBonusDesc: 'كهدية خاصة، احصل على مكتبة الترددات الاهتزازية الحصرية، المصممة لتعزيز عمل الطاقة والتأمل.',
    downloadBonus: 'حمّل هديتك المجانية الآن',
    bonusValue: 'قيمة تزيد عن 99 دولار - مجاناً لك!',
    
    // Pricing
    investInTransformation: 'استثمر في تحولك',
    pricingDesc: 'اختر الطريق الذي يقود إلى انسجامك وتوازنك الداخلي.',
    mostPopular: 'الأكثر شعبية',
    fullCourseAccess: 'الوصول الكامل للدورة',
    oneTimePayment: 'دفعة واحدة • وصول مدى الحياة',
    feature1: 'وصول مدى الحياة لجميع وحدات الدورة',
    feature2: 'تأملات موجهة حصرية',
    feature3: 'الوصول إلى منتدى المجتمع',
    feature4: 'جلسات أسئلة وأجوبة إضافية مع المدربين',
    feature5: 'كتب عمل وموارد قابلة للتحميل',
    feature6: 'شهادة إتمام',
    signInToEnroll: 'سجل دخول بجوجل للتسجيل',
    completeEnrollment: 'أكمل التسجيل',
    accessCourse: 'الوصول إلى دورتك',
    securePayment: 'دفع آمن',
    satisfactionGuarantee: 'ضمان الرضا',
    
    // Instructors
    meetYourGuides: 'تعرف على مرشديك',
    guidesDesc: 'تعلم من خبراء عالميين في شفاء الطاقة.',
    masculineEnergyMaster: 'معلم الطاقة الذكورية',
    feminineEnergyMaster: 'معلمة الطاقة الأنثوية',
    nawwafDesc: 'الدكتور نواف الشبلي قائد ذو رؤية ومرشد روحي، معروف برؤاه العميقة في الحكمة القديمة وعلم النفس الحديث. بخبرة عقود، يمكّن الأفراد من إطلاق إمكاناتهم الحقيقية وإيجاد الانسجام الداخلي.',
    inanaDesc: 'إنانا نولان معالجة طاقة ومرشدة محتفى بها، متخصصة في التجسيد الأنثوي والحسية المقدسة. نهجها الرحيم يساعد النساء على استعادة قوتهن وحدسهن وتعبيرهن الأصيل، يوجههن نحو حب الذات الجذري والحياة المتوازنة.',
    energyHealingCourse: 'دورة شفاء الطاقة',
    togetherDesc: 'معاً، يجلب الدكتور نواف وإنانا مزيجاً فريداً من الحكمة الذكورية والأنثوية، يرشدانك في رحلة شاملة نحو التوازن والتمكين.',
    
    // Testimonials
    whatStudentsSay: 'ماذا يقول طلابنا',
    testimonialsDesc: 'قصص حقيقية ممن وجدوا توازنهم.',
    testimonialRating: 'تقييم الشهادات',
    
    // Footer
    footerDesc: 'حوّل حياتك من خلال دورتنا الشاملة لشفاء الطاقة الذكورية والأنثوية. تعلم من الدكتور نواف الشبلي وإنانا نولان لتوازن وتناغم طاقاتك الداخلية.',
    quickLinks: 'روابط سريعة',
    contact: 'اتصل بنا',
    privacyPolicy: 'سياسة الخصوصية',
    termsOfService: 'شروط الخدمة',
    allRightsReserved: 'جميع الحقوق محفوظة.',
  },
  fr: {
    // Navbar
    home: 'ACCUEIL',
    about: 'À PROPOS',
    curriculum: 'PROGRAMME',
    enroll: "S'INSCRIRE",
    testimonials: 'TÉMOIGNAGES',
    login: 'Connexion',
    logout: 'Déconnexion',
    dashboard: 'Tableau de bord',
    
    // Hero Section
    masterclassAvailable: 'MASTERCLASS DISPONIBLE MAINTENANT',
    theSacred: "L'Union Sacrée",
    energyUnion: "de l'Énergie",
    heroSubtitle: 'Guérir le Masculin et le Féminin à la Racine',
    startYourJourney: 'Commencez Votre Voyage',
    exploreCurriculum: 'Explorer le Programme',
    
    // Language Section
    selectLanguage: 'Sélectionner la Langue',
    selectLanguageDesc: 'Choisissez votre langue préférée pour le contenu du site.',
    
    // Welcome Section
    welcomeMessage: 'Message de Bienvenue',
    welcomeDesc: 'Commencez votre voyage avec un message inspirant de nos instructeurs.',
    
    // Why This Course
    whyThisCourse: 'Pourquoi Ce Cours?',
    whyDesc: "Dans un monde qui nous force souvent à choisir un camp, le vrai pouvoir réside dans l'intégration. Ce cours ne consiste pas seulement à apprendre des concepts; il s'agit d'incarner tout le spectre de votre potentiel humain.",
    restoreBalance: "Restaurer l'Équilibre",
    restoreBalanceDesc: "Apprenez à osciller sainement entre l'action et le repos, donner et recevoir.",
    transformRelationships: 'Transformer les Relations',
    transformRelationshipsDesc: "Comprendre la polarité qui crée l'attraction et approfondit la connexion.",
    unlockCreativity: 'Débloquer la Créativité',
    unlockCreativityDesc: "Accédez à l'état de flow où vivent vos meilleures idées et votre expression la plus vraie.",
    spiritualPath: 'Chemin Spirituel',
    spiritualPathDesc: "Utilisez votre vie quotidienne et vos relations comme véhicule d'éveil spirituel.",
    whatYouWillExperience: 'Ce Que Vous Vivrez',
    experience1: 'Libération émotionnelle profonde et guérison des blessures passées',
    experience2: 'Clarté sur le but et la direction de votre vie',
    experience3: "Outils pour gérer le stress et l'anxiété par le travail énergétique",
    experience4: 'Une communauté de soutien de chercheurs partageant les mêmes idées',
    experience5: "Rituels pratiques pour l'alignement quotidien",
    experience6: 'Intuition et confiance en soi renforcées',
    
    // Curriculum
    courseCurriculum: 'Programme du Cours',
    curriculumDesc: 'Un voyage de transformation, module par module.',
    part1Title: "Fondements de l'Énergie",
    part1Subtitle: 'Comprendre les principes fondamentaux',
    part2Title: "L'Archétype Masculin",
    part2Subtitle: 'Éveiller le protecteur intérieur',
    part3Title: 'Le Flux Féminin',
    part3Subtitle: "Embrasser l'intuition et la créativité",
    part4Title: 'Union Divine',
    part4Subtitle: "Harmoniser les énergies pour l'intégrité",
    unlock: 'Débloquer',
    
    // Free Bonus
    freeBonus: 'Bonus Gratuit',
    freeBonusDesc: 'En cadeau spécial, recevez notre exclusive Bibliothèque de Fréquences Vibratoires, conçue pour amplifier votre travail énergétique et pratique de méditation.',
    downloadBonus: 'Téléchargez Votre Bonus Gratuit',
    bonusValue: 'Valeur de plus de 99$ - GRATUIT pour vous!',
    
    // Pricing
    investInTransformation: 'Investissez dans Votre Transformation',
    pricingDesc: "Choisissez le chemin qui mène à votre harmonie et équilibre intérieurs.",
    mostPopular: 'Le Plus Populaire',
    fullCourseAccess: 'Accès Complet au Cours',
    oneTimePayment: 'Paiement unique • Accès à vie',
    feature1: 'Accès à vie à tous les modules du cours',
    feature2: 'Méditations guidées exclusives',
    feature3: 'Accès au forum communautaire',
    feature4: 'Sessions Q&R bonus avec les instructeurs',
    feature5: 'Cahiers de travail et ressources téléchargeables',
    feature6: "Certificat d'achèvement",
    signInToEnroll: "Connectez-vous avec Google pour S'inscrire",
    completeEnrollment: "Terminer l'Inscription",
    accessCourse: 'Accéder à Votre Cours',
    securePayment: 'Paiement Sécurisé',
    satisfactionGuarantee: 'Garantie de Satisfaction',
    
    // Instructors
    meetYourGuides: 'Rencontrez Vos Guides',
    guidesDesc: "Apprenez d'experts de renommée mondiale en guérison énergétique.",
    masculineEnergyMaster: "Maître de l'Énergie Masculine",
    feminineEnergyMaster: "Maîtresse de l'Énergie Féminine",
    nawwafDesc: "Dr. Nawwaf Alshibli est un leader visionnaire et guide spirituel, reconnu pour ses profondes connaissances de la sagesse ancienne et de la psychologie moderne. Avec des décennies d'expérience, il permet aux individus de libérer leur vrai potentiel et de trouver l'harmonie intérieure.",
    inanaDesc: "Inanna Nolan est une guérisseuse énergétique et mentore célébrée, spécialisée dans l'incarnation féminine et la sensualité sacrée. Son approche compatissante aide les femmes à récupérer leur pouvoir, intuition et expression authentique, les guidant vers l'amour de soi radical et une vie équilibrée.",
    energyHealingCourse: 'Cours de Guérison Énergétique',
    togetherDesc: 'Ensemble, Dr. Nawwaf et Inanna apportent un mélange unique de sagesse masculine et féminine, vous guidant dans un voyage holistique vers équilibre et autonomisation.',
    
    // Testimonials
    whatStudentsSay: 'Ce Que Disent Nos Étudiants',
    testimonialsDesc: 'Histoires vraies de ceux qui ont trouvé leur équilibre.',
    testimonialRating: 'Note des témoignages',
    
    // Footer
    footerDesc: "Transformez votre vie grâce à notre cours complet de guérison de l'énergie masculine et féminine. Apprenez du Dr. Nawwaf Alshibli et Inanna Nolan pour équilibrer et harmoniser vos énergies intérieures.",
    quickLinks: 'Liens Rapides',
    contact: 'Contact',
    privacyPolicy: 'Politique de Confidentialité',
    termsOfService: "Conditions d'Utilisation",
    allRightsReserved: 'Tous droits réservés.',
  }
};

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState('en');

  const t = (key) => {
    return translations[language][key] || translations['en'][key] || key;
  };

  const isRTL = language === 'ar';

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t, isRTL }}>
      <div dir={isRTL ? 'rtl' : 'ltr'}>
        {children}
      </div>
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
